<template>
  <div>
    <v-progress-linear indeterminate v-if="users.length<1"></v-progress-linear>
    <div v-else>
      <v-autocomplete
          style="width:100%" v-if="users.length > 0"
          :items="users"
          item-text="username"
          v-model="userId"
          item-value="id"
          label="Pracownik"
          @change="userChanged()"
          :filter="filterUsers"
      >
        <template v-slot:selection="data">
          {{ data.item ? data.item.name + " " + data.item.surname : '' }}
        </template>
        <template v-slot:item="data">
          {{ data.item ? data.item.name + " " + data.item.surname : '' }}
        </template>
      </v-autocomplete>

      <v-data-table v-if="userId" :hide-actions="true" :headers="headers" :items="sections" class="elevation-1">
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="(header,index) in props.headers" :key="header.name+'_'+index" class="text-overflow header">
              <span class="span-blcok"> {{ header.name }} </span>
            </th>
          </tr>
        </template>

        <template v-slot:items="props">
          <td class="text-xs-center"><span>{{ props.item.name }}</span></td>
          <td class="text-xs-center">
            <v-checkbox style="margin-left: 48%" v-model="selectedReadPermissions[props.item.id]"></v-checkbox>
          </td>
          <td class="text-xs-center">
            <v-checkbox style="margin-left: 48%" v-model="selectedWritePermissions[props.item.id]"></v-checkbox>
          </td>
          <td class="text-xs-center">
            <v-checkbox style="margin-left: 48%" v-model="selectedDeletePermissions[props.item.id]"></v-checkbox>
          </td>
        </template>
      </v-data-table>
      <v-btn v-if="userId" @click="sendForm()">
        <v-icon>send</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import Checkbox from "../form/view/Checkbox.vue";
import Messenger from "../../plugins/Messenger";

const READ_WRITE =4
const EDIT = 2
const DELETE = 1

export default {
  components: {Checkbox},
  data() {
    return {
      userId: null,
      selectedReadPermissions: {},
      selectedWritePermissions: {},
      selectedDeletePermissions: {},
      users: [],
      permissions: [],
      sections: [],
      headers: [
        {name: "Sekcja"},
        {name: "Uprawnienia odczytu / zapisu"},
        {name: "Uprawnienia edycji"},
        {name: "Uprawnienia usuwania"}
      ]
    }
  },
  created() {
    let user = this.$http.get('users')
    let rules = this.$http.get('document/user-section')
    let section = this.$http.get('document/section')

    Promise.all([user, rules, section]).then(data => {
      this.users = data[0].data
      this.permissions = data[1].data
      this.sections = data[2].data
    })
  },
  methods: {
    sendForm() {
      let postData = this.getPostData()
      this.$http.post('document/user-section', postData).then(() => {
        let userSectionPermissions = this.permissions.find(userPermission => userPermission.user_id == this.userId)
        if (userSectionPermissions) {
          userSectionPermissions.sections = postData.sections
        }
        Messenger.emitSuccess("Dodano uprawnienia")
      }).catch(() => {
        Messenger.emitError("Bład. Nie można dodać uprawnień!")
      })
    },
    getPostData() {
      let sections = {}

      let permissions = [ this.selectedReadPermissions, this.selectedWritePermissions, this.selectedDeletePermissions ]
      let bitValue = [ READ_WRITE, EDIT, DELETE ] //appropriate value of the permission bit

      permissions.forEach((selectedPremissions, permissionKey) => {
        for (let key in selectedPremissions) {
          sections[key] = selectedPremissions[key] == true ? sections[key] | bitValue[permissionKey] : sections[key]

          if(!sections[key]){
            delete sections[key]
          }
        }
      })

      let result = { user_id: this.userId, sections: []  }
      for(let sectionId in sections){
        result.sections.push({"section_id" : sectionId, "permission": sections[sectionId]})
      }

      return result
    },
    userChanged() {
      this.selectedReadPermissions = {}
      this.selectedWritePermissions = {}
      this.selectedDeletePermissions = {}

      let userSectionPermissions = this.permissions.find(userPermission => userPermission.user_id == this.userId)
      if (userSectionPermissions) {
        userSectionPermissions.sections.forEach(section => {
          this.selectedReadPermissions[section.section_id] = (section.permission & READ_WRITE) == READ_WRITE
          this.selectedWritePermissions[section.section_id] = (section.permission & EDIT) == EDIT
          this.selectedDeletePermissions[section.section_id] = (section.permission & DELETE) == DELETE
        })
      }
    },
    filterUsers(user, text) {
      return (user.name + ' ' + user.surname).toLowerCase().includes(text.toLowerCase()) ||
          user.username.toString().includes(text)
    }
  },
}
</script>

<style scoped>

</style>